import { FreeTimeActions } from 'src/store/actions/freeTimeActions';
import Utils from 'src/utils';
const initialState = {
    freeTime: {},
    freeTimeLoading: false
};
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case FreeTimeActions.GET_FREE_TIME_REQUEST: {
            return {
                ...state,
                freeTimeLoading: true
            };
        }
        case FreeTimeActions.GET_FREE_TIME_SUCCESS: {
            return {
                ...state,
                freeTime: payload,
                freeTimeLoading: false
            };
        }
        case FreeTimeActions.GET_FREE_TIME_FAIL: {
            return {
                ...state,
                freeTimeLoading: false
            };
        }
        case FreeTimeActions.POST_FREE_TIME_REQUEST: {
            return {
                ...state,
                freeTimeLoading: true
            };
        }
        case FreeTimeActions.POST_FREE_TIME_SUCCESS: {
            const updatedFreeTime = Utils.arrays.mergeWithNestedObjectsReplace(state.freeTime.Data, [payload], 'Id');
            return {
                ...state,
                freeTime: {
                    ...state.freeTime,
                    Data: updatedFreeTime
                },
                freeTimeLoading: false
            };
        }
        case FreeTimeActions.POST_FREE_TIME_FAIL: {
            return {
                ...state,
                freeTimeLoading: false
            };
        }
        default:
            return state;
    }
};
